<template>
  <span>
    <el-popover v-if="dataList.length > 1"
                placement="right"
                width="400"
                trigger="click"
                >
      <div class="title" v-bind:class="getTitleClass()">{{ getTitle() }}</div>
      <div>
        <table width="100%" cellspacing="0" cellpadding="0" class="table-more-list">
          <tr v-for="(data, index) in tableDataList"
              :key="`more-item-${index}`">
            <td width="70%">{{data}}</td>
          </tr>
        </table>
        <div style="margin-top: 10px">
          <div style="margin-top: 10px">
            <div class="el-pagination is-background">
              <button type="button" class="btn-prev"
                      :disabled="currentPage === 1"
                      @click="changePage('prev')">
                <i class="el-icon el-icon-arrow-left"></i>
              </button>
              <button type="button" class="btn-next"
                      :disabled="currentPage === maxPage"
                      @click="changePage('next')">
                <i class="el-icon el-icon-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <el-button slot="reference" @click="stopProp($event)" :type="getType()" size="mini" class="more-item-button">
        {{ $t('more') }} (<strong>{{ dataList.length - 1 }}</strong>)
      </el-button>
    </el-popover>
  </span>
</template>
<script>
import i18nMessages from '@/translations/Email/ManageEmail/EmailHistory/components/PopoverViewMoreItemComponent.i18n'
import { getDataOnPaging, adjustCurrentPage } from '@/services/general-service'
import { cloneDeep } from 'lodash'

export default {
  name: 'PopoverViewMoreItemComponent',
  i18n: { messages: i18nMessages },
  props: {
    dataList: {
      type: Array,
      default: () => {
        return []
      }
    },
    listType: {
      type: String,
      default: 'to'
    }
  },
  data () {
    return {
      tableDataList: [],
      emailType: ['to', 'cc', 'bcc'],
      currentPage: 1,
      pageSize: 10,
      maxPage: 1,
      visible: false
    }
  },
  created: async function () {
    this._getTableDataList()
  },
  methods: {
    changePage: function (action) {
      if (action === 'next') {
        this.currentPage++
      } else {
        this.currentPage--
      }

      this._getTableDataList()
    },
    _getTableDataList: function () {
      const dataList = cloneDeep(this.dataList)
      dataList.shift()

      this.maxPage = Math.ceil(dataList.length / this.pageSize)
      this.currentPage = adjustCurrentPage(dataList.length, this.currentPage, this.pageSize)
      this.tableDataList = getDataOnPaging(dataList, this.currentPage, this.pageSize)
    },
    getType: function () {
      const isEmailType = this.emailType.includes(this.listType)

      if (isEmailType) {
        return 'primary'
      }

      if (this.listType === 'agent') {
        return 'warning'
      }

      if (this.listType === 'agentType') {
        return 'info'
      }

      return 'success'
    },
    getTitle: function () {
      if (this.listType === 'to') {
        return this.$t('to')
      }

      if (this.listType === 'cc') {
        return this.$t('cc')
      }

      if (this.listType === 'bcc') {
        return this.$t('bcc')
      }

      if (this.listType === 'agent') {
        return this.$t('agentList')
      }

      if (this.listType === 'agentType') {
        return this.$t('agentTypeList')
      }

      return this.$t('marketList')
    },
    getTitleClass: function () {
      const isEmailType = this.emailType.includes(this.listType)

      if (isEmailType) {
        return { 'title-email': true }
      }

      if (this.listType === 'agentType') {
        return { 'title-agent-type': true }
      }

      if (this.listType === 'agent') {
        return { 'title-agent': true }
      }

      return { 'title-market': true }
    },
    stopProp: function (event) {
      event.stopPropagation()
    }

  }
}
</script>
<style scoped>
  .table-more-list {
    width: 100%;
  }
  .table-more-list td {
    padding: 5px;
    border-bottom: 1px #efeded solid;
  }
  .table-more-list tr:last-child > td {
    border-bottom-width: 0px;
  }
  .title {
    width: 412px;
    height: 31px;
    color: #ffffff;
    vertical-align: middle;
    padding-top: 10px;
    margin-top: -12px;
    padding-left: 12px;
    margin-left: -12px;
    margin-bottom: 10px;
  }
  .title-email {
    background: #409EFF;
  }
  .title-market {
    background: #67C23A;
  }
  .title-agent-type {
    background: #909399;
  }
  .title-agent {
    background: #E6A23C;
  }
  .button-more {
    border-radius: 25px;
  }
  .more-item-button {
    border-radius: 25px !important;
  }

  .el-button--mini, .el-button--mini.is-round {
    padding: 4px 7px !important;
  }
</style>
